import {createContext, useContext, useEffect} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

import {getCookie} from '../api/cookie';

const AuthContext = createContext(null);

export function AuthContextProvider({ children }) {
    const navigate = useNavigate();

    const location = useLocation();
    const currentPath = location.pathname;
    
    const accessToken = getCookie('accessToken');
    const administrator = getCookie('administrator');
    
    useEffect(() => {
        // 1. token이 없는데 auth와 관련된 페이지 외 다른 페이지에 접근하려는 경우 : 로그인 페이지로 리다이렉트
        if (!accessToken && !currentPath.startsWith('/auth')) {
            navigate('/auth/login', { replace: true });
            return;
        }
        
        // 2. token이 있는데 로그인 페이지로 이동하려는 경우: 홈으로 리다이렉트
        if (accessToken && currentPath === '/auth/login') {
            navigate('/', { replace: true });
            return;
        }
        
        // 3. isAdmin이 false인데 관리자 페이지로 접근하는 경우 : 홈으로 리다이렉트
        if (currentPath.startsWith('/admin') && !administrator) {
            navigate('/', { replace: true });
            return;
        }
    }, [accessToken, administrator, currentPath, navigate]);
    
    const value = {
        accessToken,
        administrator,
        isAuthenticated: !!accessToken // accessToken의 존재 여부를 불리언 값으로 나타내기 위한 용도
    };
    
    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuthContext() {
    return useContext(AuthContext);
}
